import { defaultSyscoinProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/syscoin/default-constants';

export const PEGASYS_CONTRACT_ADDRESS = '0x017dAd2578372CAEE5c6CddfE35eEDB3728544C4';

export const PEGASYS_PROVIDER_CONFIGURATION = defaultSyscoinProviderConfiguration;
